export const FILTER_TITLE_PLACEHOLDER = 'Enter filter';
export const AUTO_REFRESH_PLACEHOLDER = 'Every 5 min';
export const TITLE_INPUT_PLACEHOLDER = 'Enter title';
export const AUTO_REFRESH_SELECT_LABEL = 'Auto Refresh';
export const EQ_PARAMS = [
  'detectedOs',
  'detectedVendor',
  'detectedTypeBase',
  'discoveryStatus',
  'fileServerName',
  'managementState',
  'accessStatus',
];
